<template>
  <div>
    <nav-bar :content="headerContent"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavBar from '@/components/header/NavBar.vue';

export default {
  name: 'Header',
  components: { NavBar },
  created() {
    this.$store.dispatch('content/loadContentForView', 'header');
  },
  computed: {
    ...mapGetters({
      headerContent: 'content/getHeaderContent',
    }),
  },
};
</script>

<style scoped>

</style>
